import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import CreatableSelect from 'react-select/creatable';
import '../css/SubmitProfil.css';
import API_BASE_URL from '../api';
const initialSkillsOptions = [
  { value: 'java', label: 'Java' },
  { value: 'python', label: 'Python' },
  { value: 'php', label: 'PHP' },
];

const generateReference = async () => {
  let isUnique = false;
  let reference = '';
  const token = localStorage.getItem('authToken');
  
  while (!isUnique) {
    reference = `REF-${Math.floor(1000 + Math.random() * 9000)}`;
    const response = await axios.get(`${API_BASE_URL}/api/profils/check-reference/${reference}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    isUnique = response.data.isUnique;
  }

  return reference;
};

const SubmitProfil = () => {
  const [profilData, setProfilData] = useState({
    title: '',
    cvFile: null,
    availability: '',
    jobTitle: '',
    reference: '',
    location: '',
    workMode: '',
    experience: '',
    educationLevel: '',
    budgetTJM: 450,
    skills: [],
    softSkills: [],
    assignedUserId: localStorage.getItem('userId'),
    assignedUserName: localStorage.getItem('userName'),
    status: 'published',
    arrive: localStorage.getItem('arrive') // This will be included in the submission but not shown in the UI
  });

  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [skillsOptions, setSkillsOptions] = useState(initialSkillsOptions);
  const [softSkillsOptions, setSoftSkillsOptions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReference = async () => {
      const reference = await generateReference();
      setProfilData((prevData) => ({
        ...prevData,
        reference
      }));
    };

    fetchReference();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setProfilData({
      ...profilData,
      [name]: type === 'checkbox' ? checked : type === 'file' ? files[0] : value
    });
  };

  const handleBudgetChange = (e) => {
    setProfilData({
      ...profilData,
      budgetTJM: e.target.value
    });
  };

  const handleBudgetInputChange = (e) => {
    const value = e.target.value;
    if (!isNaN(value) && value >= 100 && value <= 1800) {
      setProfilData({
        ...profilData,
        budgetTJM: value
      });
    }
  };

  const handleSkillsChange = (selectedOptions) => {
    setProfilData({
      ...profilData,
      skills: selectedOptions.map(option => option.value)
    });
  };

  const handleSoftSkillsChange = (selectedOptions) => {
    setProfilData({
      ...profilData,
      softSkills: selectedOptions.map(option => option.value)
    });
  };

  const handleCreateSkill = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    setSkillsOptions([...skillsOptions, newOption]);
    setProfilData({
      ...profilData,
      skills: [...profilData.skills, inputValue]
    });
  };

  const handleCreateSoftSkill = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    setSoftSkillsOptions([...softSkillsOptions, newOption]);
    setProfilData({
      ...profilData,
      softSkills: [...profilData.softSkills, inputValue]
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('authToken');
    const formData = new FormData();
    formData.append('title', profilData.title);
    formData.append('cvFile', profilData.cvFile);
    formData.append('availability', profilData.availability);
    formData.append('jobTitle', profilData.jobTitle);
    formData.append('reference', profilData.reference);
    formData.append('location', profilData.location);
    formData.append('workMode', profilData.workMode);
    formData.append('experience', profilData.experience);
    formData.append('educationLevel', profilData.educationLevel);
    formData.append('budgetTJM', profilData.budgetTJM);
    formData.append('skills', JSON.stringify(profilData.skills));
    formData.append('softSkills', JSON.stringify(profilData.softSkills));
    formData.append('assignedUserId', profilData.assignedUserId);
    formData.append('assignedUserName', profilData.assignedUserName);
    formData.append('status', profilData.status);
    formData.append('arrive', profilData.arrive);

    try {
      const response = await axios.post(`${API_BASE_URL}/api/profils`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      setSuccess('Profil publié avec succès');
      setError('');
      navigate(`/profils/${response.data._id}`);
    } catch (error) {
      console.error('Error creating profil:', error);
      setError('Erreur lors de la soumission du profil');
      setSuccess('');
    }
  };
  
  return (
    <div className="submit-profil-container">
      <Sidebar />
      <div className="main-content">
        <div className="profil-container">
          <div className="profil-header">
            <h2>Publier un profil</h2>
          </div>
          <form className="submit-profil-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="reference">Votre référence</label>
              <input
                type="text"
                id="reference"
                name="reference"
                value={profilData.reference}
                readOnly
              />
            </div>
            <div className="form-group">
              <label htmlFor="title">Titre du profil</label>
              <input
                type="text"
                id="title"
                name="title"
                value={profilData.title}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="cvFile">Joindre le CV</label>
              <input
                type="file"
                id="cvFile"
                name="cvFile"
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="availability">Disponibilité</label>
              <input
                type="date"
                id="availability"
                name="availability"
                value={profilData.availability}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="jobTitle">Poste recherché</label>
              <input
                type="text"
                id="jobTitle"
                name="jobTitle"
                value={profilData.jobTitle}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="location">Mobilité</label>
              <input
                type="text"
                id="location"
                name="location"
                value={profilData.location}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="workMode">Mode de travail</label>
              <select
                id="workMode"
                name="workMode"
                value={profilData.workMode}
                onChange={handleChange}
                required
              >
                <option value="">Sélectionner...</option>
                <option value="Présentiel">100% Présentiel</option>
                <option value="Télétravail">100% Télétravail</option>
                <option value="Partiel">Télétravail partiel</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="experience">Années d'expérience</label>
              <select
                id="experience"
                name="experience"
                value={profilData.experience}
                onChange={handleChange}
                required
              >
                <option value="">Sélectionner...</option>
                <option value="Moins de 2 ans">Moins de 2 ans</option>
                <option value="2 à 5 ans">2 à 5 ans</option>
                <option value="5 à 10 ans">5 à 10 ans</option>
                <option value="Plus de 10 ans">Plus de 10 ans</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="educationLevel">Niveau d'études</label>
              <select
                id="educationLevel"
                name="educationLevel"
                value={profilData.educationLevel}
                onChange={handleChange}
                required
              >
                <option value="">Sélectionner...</option>
                <option value="Bac">Bac</option>
                <option value="Bac+2">Bac+2</option>
                <option value="Bac+3">Bac+3</option>
                <option value="Bac+5">Bac+5</option>
                <option value="Bac+8">Bac+8</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="budgetTJM">TJM</label>
              <div className="budget-slider">
                <input
                  type="range"
                  id="budgetTJM"
                  name="budgetTJM"
                  min="100"
                  max="1800"
                  value={profilData.budgetTJM}
                  onChange={handleBudgetChange}
                  required
                />
                <input
                  type="number"
                  id="budgetTJMInput"
                  name="budgetTJMInput"
                  min="100"
                  max="1800"
                  value={profilData.budgetTJM}
                  onChange={handleBudgetInputChange}
                  required
                />
                <span>{`${profilData.budgetTJM}€`}</span>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="skills">Compétences techniques</label>
              <CreatableSelect
                id="skills"
                name="skills"
                isMulti
                options={skillsOptions}
                onChange={handleSkillsChange}
                onCreateOption={handleCreateSkill}
                value={skillsOptions.filter(option => profilData.skills.includes(option.value))}
                placeholder="Rechercher une compétence..."
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="softSkills">Soft skills</label>
              <CreatableSelect
                id="softSkills"
                name="softSkills"
                isMulti
                options={softSkillsOptions}
                onChange={handleSoftSkillsChange}
                onCreateOption={handleCreateSoftSkill}
                value={softSkillsOptions.filter(option => profilData.softSkills.includes(option.value))}
                placeholder="Rechercher un savoir-être..."
                required
              />
            </div>
            {error && <div className="alert alert-danger mt-3">{error}</div>}
            {success && <div className="alert alert-success mt-3">{success}</div>}
            <div className="form-actions">
              <button type="submit" className="publish-button">
                Publier
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SubmitProfil;
